<template>
  <div>
    <a-table
      :columns="columns"
      :dataSource="document.HISTORY"
      :pagination="{ pageSize: 15 }"
      size="middle"
      bordered
    ></a-table>
    <div style="margin-bottom: 15px;text-align:center">
      <a-button type="danger" @click="handlerBack">{{$t('Close')}}</a-button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["document", "info", "prew_history"],
  data() {
    let changeLocals = {
      document_type: this.$t("Document type"),
      date_send: this.$t("Date of receiving"),
      date_recept: this.$t("Date of receiving"),
      title: this.$t("Document name"),
      my_company: this.$t("main_company_n_hub"),
      kontragent: this.$t("Contractor"),
      comments: this.$t("Comment"),
      mpk: this.$t("MPK"),
      SPECJALIZACJA: this.$t("Specialization"),
      num_doc: this.$t("Document number"),
      tags: this.$t("Keywords"),
      key_words: this.$t("Keywords"),
      Teczka: this.$t("Tag"),
      arch_doc_type: this.$t("Original"),
      arch_doc_number: this.$t("Folder number")
    };
    const columns = [
      {
        title: this.$t("Date of change"),
        dataIndex: "date_change",
        width: 200
      },
      {
        title: this.$t("User"),
        dataIndex: "creator",
        width: 300,
        customRender: text => {
          let user = this.document.userList.find(x => x.ID == text);
          return user.NAME + " " + user.LAST_NAME;
        }
      },
      {
        title: this.$t("Change type"),
        dataIndex: "type_change",
        width: 150,
        customRender: text => {
          return changeLocals[text];
        }
      },
      {
        title: this.$t("Old value"),
        dataIndex: "old",
        ellipsis: true,
        width: "30%",
        customRender: (text, record) => {
          if (record.type_change in this.info) {
            let comp = this.info[record.type_change].find(x => x.ID == text);
            return comp != undefined ? comp.TITLE : "";
          } else if (record.type_change == "kontragent") {
            let comp = this.info.company.find(x => x.ID == text);
            return comp != undefined ? comp.TITLE : "";
          } else if (record.type_change == "key_words" && Array.isArray(text)) {
            return text.reduce(
              (accumulator, currentValue) => accumulator + ", " + currentValue
            );
          } else {
            return text == "null" ? "" : text;
          }
        }
      },
      {
        title: this.$t("New value"),
        dataIndex: "new",
        ellipsis: true,
        width: "30%",
        customRender: (text, record) => {
          if (record.type_change in this.info) {
            let comp = this.info[record.type_change].find(x => x.ID == text);
            return comp.TITLE;
          } else if (record.type_change == "kontragent") {
            let comp = this.info.company.find(x => x.ID == text);
            return comp != undefined ? comp.TITLE : "";
          } else if (record.type_change == "key_words" && Array.isArray(text)) {
            return text.reduce(
              (accumulator, currentValue) => accumulator + ", " + currentValue
            );
          } else {
            return text == "null" ? "" : text;
          }
        }
      }
    ];
    return {
      count: 10,
      document_record: 0,
      columns
    };
  },
  methods: {
    handlerBack() {
      this.$emit("onBack");
    }
  }
};
</script>
<style scoped>
</style>
